import { HackleUser } from "../../../../model/model"
import Workspace from "../../../../workspace/Workspace"
import EvaluateResponse from "../../../EvaluateResponse"
import Evaluation from "../../../Evaluation"
import { EvaluatorContext } from "../../../evaluator/Evaluator"
import { InAppMessageLayoutEvaluateResponse } from "../layout/InAppMessageLayoutEvaluateResponse"
import { InAppMessageEligibilityEvaluation } from "./InAppMessageEligibilityEvaluation"
import { InAppMessageEligibilityEvaluateResult } from "./InAppMessageEligibilityEvaluateResult"
import { InAppMessageEligibilityEvaluateRequest } from "./InAppMessageEligibilityEvaluateRequest"

export class InAppMessageEligibilityEvaluateResponse implements EvaluateResponse {
  constructor(
    readonly user: HackleUser,
    readonly workspace: Workspace,
    readonly evaluation: InAppMessageEligibilityEvaluation,
    readonly references: Evaluation[],
    readonly layout: InAppMessageLayoutEvaluateResponse | null
  ) {}

  static of(
    request: InAppMessageEligibilityEvaluateRequest,
    context: EvaluatorContext,
    result: InAppMessageEligibilityEvaluateResult
  ): InAppMessageEligibilityEvaluateResponse {
    return new InAppMessageEligibilityEvaluateResponse(
      request.user,
      request.workspace,
      new InAppMessageEligibilityEvaluation(request.inAppMessage, result),
      context.references,
      context.get(InAppMessageLayoutEvaluateResponse)
    )
  }
}
